import React from 'react';
import PropTypes from 'prop-types';
import Table from './Table';
import Context from './Context';

export default function Index({ memberId }) {
  return (
    <Context>
      <div className="ibox">
        <div className="ibox-content">
          <Table memberId={memberId} />
        </div>
      </div>
    </Context>
  );
}

Index.propTypes = {
  memberId: PropTypes.number.isRequired,
};
